import React from 'react';
import { PaymentMethod } from '../../../../payment-methods/payment-method-selection-dialog';

const getMethodConfig = (methodType: PaymentMethod) => {
  switch (methodType) {
    case PaymentMethod.CreditCard:
      return {
        icon: 'pi pi-credit-card',
        color: '#2196F3',
        label: 'כרטיס אשראי',
      };
    case PaymentMethod.BankTransfer:
      return {
        icon: 'pi pi-send',
        color: '#4CAF50',
        label: 'העברה בנקאית',
      };
    case PaymentMethod.Check:
      return {
        icon: 'pi pi-money-bill',
        color: '#FF9800',
        label: "צ'ק",
      };
    case PaymentMethod.Scholarship:
      return {
        icon: 'pi pi-book',
        color: '#9C27B0',
        label: 'מלגה',
      };
    case PaymentMethod.Cash:
      return {
        icon: 'pi pi-wallet',
        color: '#795548',
        label: 'מזומן',
      };
    default:
      return {
        icon: 'pi pi-question-circle',
        color: '#9E9E9E',
        label: 'אחר',
      };
  }
};

export interface PaymentMethodIconProps {
  methodType: PaymentMethod;
}
export const PaymentMethodIcon: React.FC<PaymentMethodIconProps> = ({
  methodType,
}) => {
  const config = getMethodConfig(methodType);

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
      <i
        className={config.icon}
        style={{ color: config.color, fontSize: '1.2rem' }}
      />
      <span style={{ color: '#495057' }}>{config.label}</span>
    </div>
  );
};
